import React from 'react'
import styled from 'styled-components'
import { motion } from 'motion/react'
import Confetti from 'react-confetti'
import Button from './atoms/Buttons'
import { ContentButtons } from './ButtonCustom'

const Overlay = styled(motion.div)`
  position: absolute;
  inset: 0;
  z-index: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px;
  background: rgba(18, 5, 0, 0.38);
  -webkit-backdrop-filter: blur(18px);
  backdrop-filter: blur(18px);
`

const ModalContent = styled(motion.div)`
  width: min(88vw, 1100px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 28px;
`

const ModalActions = styled(ContentButtons)`
  margin: 0;
`

export const ModalActionButton = styled(Button)`
  min-width: 260px;
`

const ProgressiveLevelModal = ({
  onClose,
  closeOnOverlayClick = false,
  showConfetti = false,
  confettiWidth,
  confettiHeight,
  children,
  actions,
}) => {
  const handleOverlayClick = () => {
    if (closeOnOverlayClick && onClose) {
      onClose()
    }
  }

  const handleContentClick = (event) => {
    if (closeOnOverlayClick) {
      event.stopPropagation()
    }
  }

  return (
    <Overlay
      onClick={handleOverlayClick}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.25 }}
    >
      {showConfetti && (
        <Confetti
          width={confettiWidth}
          height={confettiHeight}
          opacity={0.8}
        />
      )}

      <ModalContent
        onClick={handleContentClick}
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 30 }}
        transition={{ duration: 0.28, ease: 'easeOut' }}
      >
        {children}
        {actions && <ModalActions>{actions}</ModalActions>}
      </ModalContent>
    </Overlay>
  )
}

export default ProgressiveLevelModal
